import { GroupsEnum } from "@/enum/groups";
import { RoleEnum } from "@/enum/role";
import RegionalSubstitutionRoutes from "@/pages/financial/regional-substitution/regional-substitution.routes";
import ReportBalanceCashRoutes from "@/pages/financial/report-balance-cash/report-balance-case.routes";
import ReversalMadeRoutes from "@/pages/financial/reversal-made/financial.routes";
import StoreAccessQueryRoutes from "@/pages/financial/store-access-query/store-access-query.routes";
import StoreBankAccountRoutes from "@/pages/financial/store-bank-account/store-bank-account.routes";
import StoreDepositMaintenanceRoutes from "@/pages/financial/store-deposit-maintenance/store-deposit-maintenance.routes";
import StoreDepositOptionRoutes from "@/pages/financial/store-deposit-option/store-deposit-option.routes";
import StoreInvoiceListingRoutes from "@/pages/financial/store-invoice-listing/store-invoice-listing.routes";
import TermValidationRoutes from "@/pages/financial/term-validation/term-requests.routes";
import TransactionReversalRoutes from "@/pages/financial/transaction-reversal/financial.routes";
import AccessRequestRoutes from "@/pages/tax/access-request/access-request.routes";
import { Landmark, SearchIcon, UserCog, Users2Icon } from "lucide-react";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { HiDocumentReport } from "react-icons/hi";
import { createRoute } from "../createRoute";
import { PATH_IDS } from "../path-ids";

export const financialRoutes = [
  createRoute({
    id: "Estorno de movimentação",
    category: "Estorno",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/estorno-de-movimentacao/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <TransactionReversalRoutes />,
    Icon: FaFileInvoiceDollar,
  }),
  createRoute({
    id: "Estornos Realizados",
    category: "Estorno",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/estornos-realizados/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <ReversalMadeRoutes />,
    Icon: FaFileInvoiceDollar,
  }),
  createRoute({
    id: "Requisições de Acesso",
    category: "Acessos",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/requisicao-de-acesso/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <AccessRequestRoutes />,
    Icon: Users2Icon,
  }),
  createRoute({
    id: "Consulta de Acessos",
    category: "Acessos",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/consulta-acessos/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <StoreAccessQueryRoutes />,
    Icon: SearchIcon,
  }),
  createRoute({
    id: "Validação de Termos",
    category: "Tesouraria",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/validacao-de-termos/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <TermValidationRoutes />,
    Icon: FaFileInvoiceDollar,
  }),
  createRoute({
    id: "Relatório de Solicitações de Saldo",
    category: "Tesouraria",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/relatorio-de-solicitacao/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <ReportBalanceCashRoutes />,
    Icon: HiDocumentReport,
  }),
  createRoute({
    id: "Opção de Depósito",
    category: "Administrativo",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/opcao-deposito/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <StoreDepositOptionRoutes />,
    Icon: Landmark,
  }),
  createRoute({
    id: "Manutenção de Depósitos",
    category: "Administrativo",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/manutencao-deposito/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <StoreDepositMaintenanceRoutes />,
    Icon: Landmark,
  }),
  createRoute({
    id: "Consulta NFe",
    category: "Administrativo",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/consulta-nfe/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <StoreInvoiceListingRoutes />,
    Icon: FaFileInvoiceDollar,
  }),
  createRoute({
    id: "Contas Correntes",
    category: "Administrativo",
    requiredRole: [RoleEnum.ANALISTA, RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/contas-correntes/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <StoreBankAccountRoutes />,
    Icon: Landmark,
  }),
  createRoute({
    id: "Substituição de Regional",
    category: "Administrativo",
    requiredRole: [RoleEnum.ADMINISTRADOR],
    groupRequired: [GroupsEnum.FINANCEIRO],
    path: "/substituicao-regional/*",
    pathId: PATH_IDS.FINANCEIRO,
    element: <RegionalSubstitutionRoutes />,
    Icon: UserCog,
  }),
];
